// extracted by mini-css-extract-plugin
export default {"container":"Warning_container__le1Wz","text":"Warning_text__tRaQL","boxed":"Warning_boxed__Mhmca"};